import { render, staticRenderFns } from "./StaffAnnualLeave.vue?vue&type=template&id=ce66807c&scoped=true&"
import script from "./StaffAnnualLeave.vue?vue&type=script&lang=js&"
export * from "./StaffAnnualLeave.vue?vue&type=script&lang=js&"
import style0 from "./StaffAnnualLeave.vue?vue&type=style&index=0&id=ce66807c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce66807c",
  null
  
)

export default component.exports